import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

const ListTaskStatusTypePage = loadable(() => import('./ListTaskStatusTypePage'), {
  fallback: <Loader />
});
const AddTaskStatusTypePage = loadable(() => import('./AddTaskStatusTypePage'), {
  fallback: <Loader />
});
const EditTaskStatusTypePage = loadable(() => import('./EditTaskStatusTypePage'), {
  fallback: <Loader />
});

const TaskStatusTypeRoutes = ({ t, setTabLoading, alert }) => {
  return [
    <Route
      key={'task_status_type'}
      exact
      path="/view/:projectId/task-status-type"
      element={<ListTaskStatusTypePage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key={'task_status_add'}
      exact
      path="/view/:projectId/task-status-type/add"
      element={<AddTaskStatusTypePage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key={'task_status_edit'}
      exact
      path="/view/:projectId/task-status-type/:taskStatusTypeId/edit"
      element={<EditTaskStatusTypePage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />
  ];
};
TaskStatusTypeRoutes.propTypes = {};
export default TaskStatusTypeRoutes;
